module.exports = __webpack_public_path__ + "img/page.8c878e49.png";